var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("path", {
    attrs: {
      d: "M27.984 0c-.55.01-.99.487-.983 1.068v6.72c-1.826-2.495-4.712-4.116-7.956-4.116v-.004a.99.99 0 00-.877.523 1.106 1.106 0 000 1.063.99.99 0 00.877.523c3.99 0 7.242 2.975 7.843 6.865h-4.015v.004a5.054 5.054 0 00-3.516 1.438c-.927.903-1.526 2.254-1.315 3.713l5.128 35.382c.731 5.06 9.085 5.142 9.664-.037l5.124-35.35c.21-1.458-.388-2.809-1.315-3.712a5.054 5.054 0 00-3.516-1.438h-3.995c.606-3.908 3.87-6.86 7.838-6.86a.99.99 0 00.877-.524 1.106 1.106 0 000-1.063.99.99 0 00-.877-.523c-3.233 0-6.141 1.595-7.971 4.095v-6.7a1.086 1.086 0 00-.294-.76.973.973 0 00-.72-.307zm-5.111 14.756h10.254a3.21 3.21 0 012.162.882c.54.526.795 1.143.694 1.841l-.523 3.618H28v2.11h7.152l-.917 6.329H28v2.11h5.93l-.916 6.329H28v2.11h4.706l-.917 6.328H28v2.11h3.484l-.628 4.335a1.111 1.111 0 00-.004.033c-.3 2.706-5.341 2.503-5.708-.033l-5.127-35.379c-.101-.698.154-1.315.694-1.841a3.21 3.21 0 012.162-.882z",
      fill: "#007C84",
      "fill-rule": "nonzero",
      stroke: "#0184C6",
      "stroke-width": ".3",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }